module.exports = __webpack_public_path__ + "static/guide_1-64e564c241b251955be9f209e123bec7.jpg";